import styled, { css } from "styled-components";

const backgroundColor = ({ theme }) => {
  return theme.colors.primary.vividCerulean;
};

const disabledBackgroundColor = ({ theme }) => {
  return theme.colors.neutral.gray2;
};

const fontSize = ({ size }) => {
  switch (size) {
    default:
      return "14px";
  }
};

const focusBorderColor = ({ theme }) => {
  return theme.colors.feedbackState.info.hover;
};

const color = ({ disabled, theme }) => {
  if (disabled) return theme.colors.neutral.gray6;

  return theme.colors.neutral.neutral8;
};

export const Wrapper = styled.label`
  border: none;
  color: ${color};
  display: grid;
  gap: 8px;
  grid-template-columns: 16px auto;
  max-width: 300px;
  position: relative;
  position: relative;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

export const TextLabel = styled.p`
  display: -webkit-box;
  align-items: flex-start;
  gap: 4px;
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  line-height: 18px;
  text-align: left;

  a {
    color: ${color};
    cursor: pointer;
    font-family: ${({ theme }) => theme.font.fontFamily};
    font-size: ${fontSize};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    line-height: 18px;
    text-decoration: underline;
  }
`;

export const HiddenCheckboxStylesStructure = styled.input`
  accent-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  border-radius: 4px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  z-index: 1;
  /* O input invisível cobre a 1ª linha do label e, por estar acima no
     stacking, capturava o clique de links/elementos dentro do customLabel
     (só a parte fora dele ficava clicável). Como o Wrapper é um <label
     htmlFor>, o toggle continua funcionando pelo clique no label/caixa e
     pelo teclado; pointer-events:none libera o clique para o conteúdo. */
  pointer-events: none;

  &:focus {
    /* border: 1px solid ${focusBorderColor}; */
    display: block;
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    accent-color: ${disabledBackgroundColor};
  }
`;

export const CheckboxDisplayed = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  aspect-ratio: 1;
  background-color: ${({ theme }) => theme.colors.neutral.black};
  border: ${({ theme }) => `2px solid ${theme.colors.neutral.white}`};
  cursor: pointer;

  z-index: 2;

  svg {
    display: ${({ checked }) => (checked ? "block" : "none")};
  }
`;
